var Intesa = Intesa || {};

Intesa.SelectCurrencies = function() {
	var bankName = $("[data-bank]").attr('data-bank');
	
	this.init = function() {	
		if(bankName == 'BIB'){
			
			$('select[name="fromCurrency"]').on('change', function(e){
				var select = $('select[name="toCurrency"]');
				var value = $(this).val();
				if(value != "RSD"){
					select.find("option[value=EUR_NET]").hide();
				} else {
					select.find("option[value=EUR_NET]").show();

				}
			});
			$('select[name="toCurrency"]').on('change', function(e){
				var select = $('select[name="fromCurrency"]');
				var value = $(this).val();
				if(value != "RSD"){
					select.find("option[value=EUR_NET]").hide();
				} else {
					select.find("option[value=EUR_NET]").show();

				}
			});
			
			$('select[name="fromCurrency"]').on('click', function(e){
				var select = $('select[name="toCurrency"]');
				var attr = select.attr("custom-disabled");
				if(typeof attr !== 'undefined' && attr !== false){
					select.removeAttr("custom-disabled");
					select.removeClass("custom-disabled");

				}
				var value = $(this).val();
				if(value == 'EUR_NET'){
					select.val("RSD");
					select.attr('custom-disabled', 'custom-disabled');
					select.addClass("custom-disabled");
				}
			});
	
			$('select[name="toCurrency"]').on('click', function(e){
				var select = $('select[name="fromCurrency"]');
				var attr = select.attr("custom-disabled");
				if(typeof attr !== 'undefined' && attr !== false){
					select.removeAttr("custom-disabled");
					select.removeClass("custom-disabled");
				}
				var value = $(this).val();
				if(value == 'EUR_NET'){
					select.val("RSD");
					select.attr('custom-disabled', 'custom-disabled');
					select.addClass("custom-disabled");
				}
			});
		}
	}
	
};

Intesa.SelectCurrencies.getInstance = function() {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.selectCurrencies ) {
		
		window.intesa.selectCurrencies = new Intesa.SelectCurrencies();
		
	}
	
	return window.intesa.selectCurrencies;

};